// app/javascript/controllers/resend_countdown_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button", "label"]
    static values = {
        seconds: Number,
        readyText: { type: String, default: "Send a new code" }
    }

    connect() {
        this.remaining = this.secondsValue || 0
        this.tick()
        this.timer = setInterval(() => this.tick(), 1000)
    }

    disconnect() {
        if (this.timer) clearInterval(this.timer)
    }

    tick() {
        if (this.remaining <= 0) {
            this.buttonTarget.disabled = false
            this.buttonTarget.classList.remove("opacity-50", "cursor-not-allowed")
            this.labelTarget.textContent = this.readyTextValue
            clearInterval(this.timer)
            return
        }

        this.buttonTarget.disabled = true
        this.buttonTarget.classList.add("opacity-50", "cursor-not-allowed")
        this.labelTarget.textContent = `Send a new code in 0:${String(this.remaining).padStart(2, "0")}`
        this.remaining -= 1
    }
}